import React from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { injectIntl, FormattedDate, FormattedNumber } from 'react-intl';
import { round as _round, isEmpty as _isEmpty, get as _get, orderBy as _orderBy } from 'lodash';
import moment from 'moment';
import 'moment-timezone';

class VklBusinessWinleas extends React.Component {
  getWinleasSubsidy = winleas => {
    const {
      intl: { messages },
      projectConfig,
    } = this.props;

    return (
      <div>
        <h5>{messages.sad.subsidy}</h5>
        <Table responsive hover condensed>
          <tbody>
            <tr>
              <td>{messages.sad.subsidy_contract_partner}</td>
              <td class="text-right" />
              <td class="text-right">
                {winleas.subsidy_contract_partner_amount >= 0 ? (
                  <FormattedNumber
                    value={winleas.subsidy_contract_partner_amount}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>
                {messages.sad.subsidy_contract_partner} {messages.sad.shortcut_lp_kp}
              </td>
              <td class="text-right">
                {winleas.subsidy_contract_partner_percentage_lp ? (
                  <FormattedNumber
                    value={_round(winleas.subsidy_contract_partner_percentage_lp, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
              <td class="text-right">
                {winleas.subsidy_contract_partner_percentage_kp ? (
                  <FormattedNumber
                    value={_round(winleas.subsidy_contract_partner_percentage_kp, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.subsidy_factory}</td>
              <td class="text-right" />
              <td class="text-right">
                {winleas.subsidy_factory_amount >= 0 ? (
                  <FormattedNumber
                    value={winleas.subsidy_factory_amount}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>
                {messages.sad.subsidy_factory} {messages.sad.shortcut_lp_kp}
              </td>
              <td class="text-right">
                {winleas.subsidy_factory_percentage_lp ? (
                  <FormattedNumber
                    value={_round(winleas.subsidy_factory_percentage_lp, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
              <td class="text-right">
                {winleas.subsidy_factory_percentage_kp ? (
                  <FormattedNumber
                    value={_round(winleas.subsidy_factory_percentage_kp, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.subsidy_mbvd}</td>
              <td class="text-right" />
              <td class="text-right">
                {winleas.subsidy_mbvd_amount >= 0 ? (
                  <FormattedNumber
                    value={winleas.subsidy_mbvd_amount}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>
                {messages.sad.subsidy_mbvd} {messages.sad.shortcut_lp_kp}
              </td>
              <td class="text-right">
                {winleas.subsidy_mbvd_lp ? (
                  <FormattedNumber
                    value={_round(winleas.subsidy_mbvd_lp, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
              <td class="text-right">
                {winleas.subsidy_mbvd_kp ? (
                  <FormattedNumber
                    value={_round(winleas.subsidy_mbvd_kp, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  };

  getWinleasDeduction = winleas => {
    const {
      intl: { messages },
      projectConfig,
    } = this.props;

    return (
      <div>
        <h5>{messages.sad.deduction}</h5>
        <Table responsive hover condensed>
          <tbody>
            <tr>
              <td>{messages.sad.deduction_mbl}</td>
              <td class="text-right">
                {winleas.deduction_mbl_percentage >= 0 ? (
                  <FormattedNumber
                    value={_round(winleas.deduction_mbl_percentage, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
              <td class="text-right" />
            </tr>
            <tr>
              <td>{messages.sad.deduction_mbl_interest}</td>
              <td class="text-right">
                {winleas.deduction_interest_mbl_percentage >= 0 ? (
                  <FormattedNumber
                    value={_round(winleas.deduction_interest_mbl_percentage, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
              <td class="text-right">
                {winleas.deduction_interest_mbl_amount >= 0 ? (
                  <FormattedNumber
                    value={winleas.deduction_interest_mbl_amount}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.deduction_consultant}</td>
              <td class="text-right">
                {winleas.deduction_consultant_percentage >= 0 ? (
                  <FormattedNumber
                    value={_round(winleas.deduction_consultant_percentage, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
              <td class="text-right" />
            </tr>
            <tr>
              <td>{messages.sad.deduction_consultant_interest}</td>
              <td class="text-right">
                {winleas.deduction_interest_consultant_percentage >= 0 ? (
                  <FormattedNumber
                    value={_round(winleas.deduction_interest_consultant_percentage, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
              <td class="text-right">
                {winleas.deduction_interest_consultant_amount >= 0 ? (
                  <FormattedNumber
                    value={winleas.deduction_interest_consultant_amount}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  };

  getWinleasDiscount = winleas => {
    const {
      intl: { messages },
      projectConfig,
    } = this.props;

    return (
      <div>
        <h5>{messages.sad.discount}</h5>
        <Table responsive hover condensed>
          <tbody>
            <tr>
              <td>{messages.sad.discount_cash}</td>
              <td class="text-right">
                {winleas.discount_cash_percentage >= 0 ? (
                  <FormattedNumber
                    value={_round(winleas.discount_cash_percentage, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
              <td class="text-right">
                {winleas.discount_cash_amount >= 0 ? (
                  <FormattedNumber
                    value={winleas.discount_cash_amount}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.discount_volume}</td>
              <td class="text-right">
                {winleas.discount_volume_percentage >= 0 ? (
                  <FormattedNumber
                    value={_round(winleas.discount_volume_percentage, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
              <td class="text-right">
                {winleas.discount_volume_amount >= 0 ? (
                  <FormattedNumber
                    value={winleas.discount_volume_amount}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.discount_environmental}</td>
              <td class="text-right">
                {winleas.discount_environment_percentage >= 0 ? (
                  <FormattedNumber
                    value={_round(winleas.discount_environment_percentage, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
              <td class="text-right">
                {winleas.discount_environment_amount >= 0 ? (
                  <FormattedNumber
                    value={winleas.discount_environment_amount}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.discount_additional}</td>
              <td class="text-right">
                {winleas.discount_additional_percentage >= 0 ? (
                  <FormattedNumber
                    value={_round(winleas.discount_additional_percentage, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
              <td class="text-right">
                {winleas.discount_additional_amount >= 0 ? (
                  <FormattedNumber
                    value={winleas.discount_additional_amount}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td class="bold">{messages.sad.commission_total}</td>
              <td class="bold text-right" />
              <td class="bold text-right">
                {winleas.discount >= 0 ? (
                  <FormattedNumber value={winleas.discount} style="currency" currency={projectConfig.data.currency} />
                ) : (
                  '-'
                )}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  };

  getWinleasCommission = winleas => {
    const {
      intl: { messages },
      projectConfig,
    } = this.props;

    return (
      <div>
        <h5>{messages.sad.commission}</h5>
        <Table responsive hover condensed>
          <tbody>
            <tr>
              <td>{messages.sad.commission_standard}</td>
              <td class="text-right">
                {winleas.commission_standard_percentage >= 0 ? (
                  <FormattedNumber
                    value={_round(winleas.commission_standard_percentage, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
              <td class="text-right">
                {winleas.commission_standard_amount >= 0 ? (
                  <FormattedNumber
                    value={winleas.commission_standard_amount}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.commission_addition_deduction}</td>
              <td class="text-right">
                {winleas.commission_addition_deducation_percentage >= 0 ? (
                  <FormattedNumber
                    value={_round(winleas.commission_addition_deducation_percentage, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
              <td class="text-right">
                {winleas.commission_addition_deducation_amount >= 0 ? (
                  <FormattedNumber
                    value={winleas.commission_addition_deducation_amount}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.commission_subsequent_scope_of_supply}</td>
              <td class="text-right">
                {winleas.commission_subsequent_scope_of_supply_percentage >= 0 ? (
                  <FormattedNumber
                    value={_round(winleas.commission_subsequent_scope_of_supply_percentage, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
              <td class="text-right">
                {winleas.commission_subsequent_scope_of_supply_amount >= 0 ? (
                  <FormattedNumber
                    value={winleas.commission_subsequent_scope_of_supply_amount}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td class="bold">{messages.sad.commission_total}</td>
              <td class="bold text-right">
                {winleas.commission_total_percentage >= 0 ? (
                  <FormattedNumber
                    value={_round(winleas.commission_total_percentage, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
              <td class="bold text-right">
                {winleas.commission_total_amount >= 0 ? (
                  <FormattedNumber
                    value={winleas.commission_total_amount}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  };

  getWinleasResidualValue = winleas => {
    const {
      intl: { messages },
      projectConfig,
    } = this.props;

    return (
      <div>
        <h5>{messages.sad.residual_value}</h5>
        <Table responsive hover condensed>
          <tbody>
            <tr>
              <td>&nbsp;</td>
              <td class="text-right">
                {messages.sad.ref} {messages.sad.list_price_short} / {messages.sad.sales_price_short}&nbsp; (
                {winleas.offer_type === 0 ? messages.sad.net : messages.sad.gross})
              </td>
              <td class="text-right">{messages.amount}</td>
            </tr>
            <tr>
              <td>{messages.sad.table_residual_value}</td>
              <td class="text-right">
                {winleas.list_table_vehicle_residual_value_percentage >= 0 ? (
                  <FormattedNumber
                    value={_round(winleas.list_table_vehicle_residual_value_percentage, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
                &nbsp;/&nbsp;
                {winleas.sales_table_vehicle_residual_value_percentage >= 0 ? (
                  <FormattedNumber
                    value={_round(winleas.sales_table_vehicle_residual_value_percentage, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
              <td class="text-right">
                {winleas.table_vehicle_residual_value >= 0 ? (
                  <FormattedNumber
                    value={winleas.table_vehicle_residual_value}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.residual_value_change}</td>
              <td class="text-right">
                {winleas.list_table_vehicle_residual_value_change_percentage >= 0 ? (
                  <FormattedNumber
                    value={_round(winleas.list_table_vehicle_residual_value_change_percentage, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
                &nbsp;/&nbsp;
                {winleas.sales_table_vehicle_residual_value_change_percentage >= 0 ? (
                  <FormattedNumber
                    value={_round(winleas.sales_table_vehicle_residual_value_change_percentage, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
              <td class="text-right">
                {winleas.table_vehicle_residual_value_change >= 0 ? (
                  <FormattedNumber
                    value={winleas.table_vehicle_residual_value_change}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td class="bold">{messages.sad.residual_value}</td>
              <td class="text-right bold">
                {winleas.list_vehicle_residual_value_percentage >= 0 ? (
                  <FormattedNumber
                    value={_round(winleas.list_vehicle_residual_value_percentage, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
                &nbsp;/&nbsp;
                {winleas.sales_vehicle_residual_value_percentage >= 0 ? (
                  <FormattedNumber
                    value={_round(winleas.sales_vehicle_residual_value_percentage, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
              <td class="text-right bold">
                {winleas.vehicle_residual_value >= 0 ? (
                  <FormattedNumber
                    value={winleas.vehicle_residual_value}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  };

  getWinLeasViewLeasingPrivate = winleas => {
    const {
      intl: { messages },
      projectConfig,
      user,
    } = this.props;

    return (
      <div>
        <Table responsive hover condensed>
          <tbody>
            <tr>
              <td>{messages.sad.financing_product}</td>
              <td class="text-right">{winleas.variant}</td>
            </tr>
            <tr>
              <td>{messages.client}</td>
              <td class="text-right">{messages.sad.client_private}</td>
            </tr>
            <tr>
              <td>{messages.sad.campaign}</td>
              <td class="text-right">
                {winleas.campaign_number} {winleas.campaign}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.list_price}</td>
              <td class="text-right">
                <FormattedNumber value={winleas.list_price} style="currency" currency={projectConfig.data.currency} />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.purchase_price}</td>
              <td class="text-right">
                <FormattedNumber
                  value={winleas.list_price - winleas.discount}
                  style="currency"
                  currency={projectConfig.data.currency}
                />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.paid_deposit_leasing}</td>
              <td class="text-right">
                <FormattedNumber value={winleas.paid_deposit} style="currency" currency={projectConfig.data.currency} />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.contract_duration}</td>
              <td class="text-right">{winleas.contract_duration_in_months}</td>
            </tr>
            <tr>
              <td>{messages.sad.total_mileage}</td>
              <td class="text-right">{winleas.total_mileage}</td>
            </tr>
            <tr>
              <td>{messages.sad.annual_percentage_rate}</td>
              <td class="text-right">
                {winleas.annual_percentage_rate ? (
                  <FormattedNumber
                    value={_round(winleas.annual_percentage_rate, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.nominal_interest_percentage_rate}</td>
              <td class="text-right">
                {winleas.nominal_interest_percentage_rate ? (
                  <FormattedNumber
                    value={_round(winleas.nominal_interest_percentage_rate, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.credit_amount}</td>
              <td class="text-right">
                <FormattedNumber
                  value={winleas.list_price - winleas.discount}
                  style="currency"
                  currency={projectConfig.data.currency}
                />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.total_amount}</td>
              <td class="text-right">
                <FormattedNumber
                  value={winleas.monthly_rate_vehicle * winleas.contract_duration_in_months}
                  style="currency"
                  currency={projectConfig.data.currency}
                />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.service_rate}</td>
              <td class="text-right">
                {winleas.service_rate ? (
                  <FormattedNumber
                    value={winleas.service_rate}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.monthly_insurance_rate}</td>
              <td class="text-right">
                {winleas.insurance_rate ? (
                  <FormattedNumber
                    value={winleas.insurance_rate}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.monthly_leasing_rate}</td>
              <td class="text-right">
                <FormattedNumber
                  value={winleas.monthly_rate_vehicle}
                  style="currency"
                  currency={projectConfig.data.currency}
                />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.application_date}</td>
              <td class="text-right">
                {_isEmpty(winleas.application_date) ? (
                  '-'
                ) : (
                  <FormattedDate
                    value={new Date(moment.tz(winleas.application_date, 'UTC').tz(user.profile.timezone))}
                  />
                )}
              </td>
            </tr>
            {!_isEmpty(winleas.application_approval_date) ? (
              <tr>
                <td class="bold">{messages.sad.application_approval_date}</td>
                <td class="bold text-right">
                  {_isEmpty(winleas.application_approval_date) ? (
                    '-'
                  ) : (
                    <FormattedDate
                      value={new Date(moment.tz(winleas.application_approval_date, 'UTC').tz(user.profile.timezone))}
                    />
                  )}
                </td>
              </tr>
            ) : null}
            {!_isEmpty(winleas.application_rejection_date) ? (
              <tr>
                <td class="bold text-danger">{messages.sad.application_rejection_date}</td>
                <td class="bold text-right text-danger">
                  {_isEmpty(winleas.application_rejection_date) ? (
                    '-'
                  ) : (
                    <FormattedDate
                      value={new Date(moment.tz(winleas.application_rejection_date, 'UTC').tz(user.profile.timezone))}
                    />
                  )}
                </td>
              </tr>
            ) : null}
          </tbody>
        </Table>
      </div>
    );
  };

  getWinLeasLeasingBusiness = winleas => {
    const {
      intl: { messages },
      projectConfig,
      user,
    } = this.props;

    return (
      <div>
        <Table responsive hover condensed>
          <tbody>
            <tr>
              <td>{messages.sad.financing_product}</td>
              <td class="text-right">{winleas.variant}</td>
            </tr>
            <tr>
              <td>{messages.client}</td>
              <td class="text-right">{messages.sad.client_business}</td>
            </tr>
            <tr>
              <td>{messages.sad.campaign}</td>
              <td class="text-right">
                {winleas.campaign_number} {winleas.campaign}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.list_price}</td>
              <td class="text-right">
                <FormattedNumber value={winleas.list_price} style="currency" currency={projectConfig.data.currency} />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.purchase_price}</td>
              <td class="text-right">
                <FormattedNumber
                  value={winleas.list_price - winleas.discount}
                  style="currency"
                  currency={projectConfig.data.currency}
                />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.paid_deposit_leasing}</td>
              <td class="text-right">
                <FormattedNumber value={winleas.paid_deposit} style="currency" currency={projectConfig.data.currency} />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.contract_duration}</td>
              <td class="text-right">{winleas.contract_duration_in_months}</td>
            </tr>
            <tr>
              <td>{messages.sad.total_mileage}</td>
              <td class="text-right">{winleas.total_mileage}</td>
            </tr>
            <tr>
              <td>{messages.sad.monthly_insurance_rate}</td>
              <td class="text-right">
                {winleas.insurance_rate ? (
                  <FormattedNumber
                    value={winleas.insurance_rate}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.service_rate}</td>
              <td class="text-right">
                {winleas.service_rate ? (
                  <FormattedNumber
                    value={winleas.service_rate}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.monthly_leasing_rate}</td>
              <td class="text-right">
                <FormattedNumber
                  value={winleas.monthly_rate_vehicle}
                  style="currency"
                  currency={projectConfig.data.currency}
                />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.application_date}</td>
              <td class="text-right">
                {_isEmpty(winleas.application_date) ? (
                  '-'
                ) : (
                  <FormattedDate
                    value={new Date(moment.tz(winleas.application_date, 'UTC').tz(user.profile.timezone))}
                  />
                )}
              </td>
            </tr>
            {!_isEmpty(winleas.application_approval_date) ? (
              <tr>
                <td class="bold">{messages.sad.application_approval_date}</td>
                <td class="bold text-right">
                  {_isEmpty(winleas.application_approval_date) ? (
                    '-'
                  ) : (
                    <FormattedDate
                      value={new Date(moment.tz(winleas.application_approval_date, 'UTC').tz(user.profile.timezone))}
                    />
                  )}
                </td>
              </tr>
            ) : null}
            {!_isEmpty(winleas.application_rejection_date) ? (
              <tr>
                <td class="bold text-danger">{messages.sad.application_rejection_date}</td>
                <td class="bold text-right text-danger">
                  {_isEmpty(winleas.application_rejection_date) ? (
                    '-'
                  ) : (
                    <FormattedDate
                      value={new Date(moment.tz(winleas.application_rejection_date, 'UTC').tz(user.profile.timezone))}
                    />
                  )}
                </td>
              </tr>
            ) : null}
          </tbody>
        </Table>
      </div>
    );
  };

  getWinLeasViewFinancingBusiness = winleas => {
    const {
      intl: { messages },
      projectConfig,
      user,
    } = this.props;

    return (
      <div>
        <Table responsive hover condensed>
          <tbody>
            <tr>
              <td>{messages.sad.financing_product}</td>
              <td class="text-right">{winleas.variant}</td>
            </tr>
            <tr>
              <td>{messages.client}</td>
              <td class="text-right">{messages.sad.client_business}</td>
            </tr>
            <tr>
              <td>{messages.sad.campaign}</td>
              <td class="text-right">
                {winleas.campaign_number} {winleas.campaign}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.list_price}</td>
              <td class="text-right">
                <FormattedNumber value={winleas.list_price} style="currency" currency={projectConfig.data.currency} />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.purchase_price}</td>
              <td class="text-right">
                <FormattedNumber
                  value={winleas.list_price - winleas.discount}
                  style="currency"
                  currency={projectConfig.data.currency}
                />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.paid_deposit}</td>
              <td class="text-right">
                <FormattedNumber value={winleas.paid_deposit} style="currency" currency={projectConfig.data.currency} />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.contract_duration}</td>
              <td class="text-right">{winleas.contract_duration_in_months}</td>
            </tr>
            <tr>
              <td>{messages.sad.total_mileage}</td>
              <td class="text-right">{winleas.total_mileage}</td>
            </tr>
            <tr>
              <td>{messages.sad.debit_interest_percentage_rate}</td>
              <td class="text-right">
                {winleas.nominal_interest_percentage_rate ? (
                  <FormattedNumber
                    value={_round(winleas.nominal_interest_percentage_rate, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.total_amount}</td>
              <td class="text-right">
                <FormattedNumber
                  value={
                    winleas.monthly_rate_vehicle * winleas.contract_duration_in_months +
                    _get(winleas, 'vehicle_residual_value', 0)
                  }
                  style="currency"
                  currency={projectConfig.data.currency}
                />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.final_instalment}</td>
              <td class="text-right">
                <FormattedNumber
                  value={winleas.vehicle_residual_value}
                  style="currency"
                  currency={projectConfig.data.currency}
                />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.service_rate}</td>
              <td class="text-right">
                {winleas.service_rate ? (
                  <FormattedNumber
                    value={winleas.service_rate}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.monthly_insurance_rate}</td>
              <td class="text-right">
                {winleas.insurance_rate ? (
                  <FormattedNumber
                    value={winleas.insurance_rate}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.monthly_financing_rate}</td>
              <td class="text-right">
                <FormattedNumber
                  value={winleas.monthly_rate_vehicle}
                  style="currency"
                  currency={projectConfig.data.currency}
                />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.application_date}</td>
              <td class="text-right">
                {_isEmpty(winleas.application_date) ? (
                  '-'
                ) : (
                  <FormattedDate
                    value={new Date(moment.tz(winleas.application_date, 'UTC').tz(user.profile.timezone))}
                  />
                )}
              </td>
            </tr>
            {!_isEmpty(winleas.application_approval_date) ? (
              <tr>
                <td class="bold">{messages.sad.application_approval_date}</td>
                <td class="bold text-right">
                  {_isEmpty(winleas.application_approval_date) ? (
                    '-'
                  ) : (
                    <FormattedDate
                      value={new Date(moment.tz(winleas.application_approval_date, 'UTC').tz(user.profile.timezone))}
                    />
                  )}
                </td>
              </tr>
            ) : null}
            {!_isEmpty(winleas.application_rejection_date) ? (
              <tr>
                <td class="bold text-danger">{messages.sad.application_rejection_date}</td>
                <td class="bold text-right text-danger">
                  {_isEmpty(winleas.application_rejection_date) ? (
                    '-'
                  ) : (
                    <FormattedDate
                      value={new Date(moment.tz(winleas.application_rejection_date, 'UTC').tz(user.profile.timezone))}
                    />
                  )}
                </td>
              </tr>
            ) : null}
          </tbody>
        </Table>
      </div>
    );
  };

  getWinLeasViewFinancingPrivate = winleas => {
    const {
      intl: { messages },
      projectConfig,
      user,
    } = this.props;

    return (
      <div>
        <Table responsive hover condensed>
          <tbody>
            <tr>
              <td>{messages.sad.financing_product}</td>
              <td class="text-right">{winleas.variant}</td>
            </tr>
            <tr>
              <td>{messages.client}</td>
              <td class="text-right">{messages.sad.client_private}</td>
            </tr>
            <tr>
              <td>{messages.sad.campaign}</td>
              <td class="text-right">
                {winleas.campaign_number} {winleas.campaign}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.list_price}</td>
              <td class="text-right">
                <FormattedNumber value={winleas.list_price} style="currency" currency={projectConfig.data.currency} />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.purchase_price}</td>
              <td class="text-right">
                <FormattedNumber
                  value={winleas.list_price - winleas.discount}
                  style="currency"
                  currency={projectConfig.data.currency}
                />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.paid_deposit}</td>
              <td class="text-right">
                <FormattedNumber value={winleas.paid_deposit} style="currency" currency={projectConfig.data.currency} />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.contract_duration}</td>
              <td class="text-right">{winleas.contract_duration_in_months}</td>
            </tr>
            <tr>
              <td>{messages.sad.total_mileage}</td>
              <td class="text-right">{winleas.total_mileage}</td>
            </tr>
            <tr>
              <td>{messages.sad.annual_percentage_rate}</td>
              <td class="text-right">
                {winleas.annual_percentage_rate ? (
                  <FormattedNumber
                    value={_round(winleas.annual_percentage_rate, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.nominal_interest_percentage_rate}</td>
              <td class="text-right">
                {winleas.nominal_interest_percentage_rate ? (
                  <FormattedNumber
                    value={_round(winleas.nominal_interest_percentage_rate, 2) / 100}
                    minimumFractionDigits="2"
                    maximumFractionDigits="2"
                    style="percent"
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.credit_amount}</td>
              <td class="text-right">
                <FormattedNumber
                  value={winleas.list_price - winleas.discount}
                  style="currency"
                  currency={projectConfig.data.currency}
                />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.total_amount}</td>
              <td class="text-right">
                <FormattedNumber
                  value={
                    winleas.monthly_rate_vehicle * winleas.contract_duration_in_months +
                    _get(winleas, 'vehicle_residual_value', 0)
                  }
                  style="currency"
                  currency={projectConfig.data.currency}
                />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.final_instalment}</td>
              <td class="text-right">
                <FormattedNumber
                  value={winleas.vehicle_residual_value}
                  style="currency"
                  currency={projectConfig.data.currency}
                />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.service_rate}</td>
              <td class="text-right">
                {winleas.service_rate ? (
                  <FormattedNumber
                    value={winleas.service_rate}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.monthly_insurance_rate}</td>
              <td class="text-right">
                {winleas.insurance_rate ? (
                  <FormattedNumber
                    value={winleas.insurance_rate}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
            <tr>
              <td>{messages.sad.monthly_financing_rate}</td>
              <td class="text-right">
                <FormattedNumber
                  value={winleas.monthly_rate_vehicle}
                  style="currency"
                  currency={projectConfig.data.currency}
                />
              </td>
            </tr>
            <tr>
              <td>{messages.sad.application_date}</td>
              <td class="text-right">
                {_isEmpty(winleas.application_date) ? (
                  '-'
                ) : (
                  <FormattedDate
                    value={new Date(moment.tz(winleas.application_date, 'UTC').tz(user.profile.timezone))}
                  />
                )}
              </td>
            </tr>
            {!_isEmpty(winleas.application_approval_date) ? (
              <tr>
                <td class="bold">{messages.sad.application_approval_date}</td>
                <td class="bold text-right">
                  {_isEmpty(winleas.application_approval_date) ? (
                    '-'
                  ) : (
                    <FormattedDate
                      value={new Date(moment.tz(winleas.application_approval_date, 'UTC').tz(user.profile.timezone))}
                    />
                  )}
                </td>
              </tr>
            ) : null}
            {!_isEmpty(winleas.application_rejection_date) ? (
              <tr>
                <td class="bold text-danger">{messages.sad.application_rejection_date}</td>
                <td class="bold text-right text-danger">
                  {_isEmpty(winleas.application_rejection_date) ? (
                    '-'
                  ) : (
                    <FormattedDate
                      value={new Date(moment.tz(winleas.application_rejection_date, 'UTC').tz(user.profile.timezone))}
                    />
                  )}
                </td>
              </tr>
            ) : null}
          </tbody>
        </Table>
      </div>
    );
  };

  getWinLeasView = winleas => {
    let generalData = null;
    if (winleas.offer_type === 0 && winleas.customer_type === 1) {
      generalData = this.getWinLeasLeasingBusiness(winleas);
    } else if (winleas.offer_type === 0 && winleas.customer_type === 2) {
      generalData = this.getWinLeasViewLeasingPrivate(winleas);
    } else if (winleas.offer_type === 1 && winleas.customer_type === 1) {
      generalData = this.getWinLeasViewFinancingBusiness(winleas);
    } else if (winleas.offer_type === 1 && winleas.customer_type === 2) {
      generalData = this.getWinLeasViewFinancingPrivate(winleas);
    }

    return (
      <div>
        <Table responsive condensed>
          <Row>
            <Col xs={6}>
              <h5>Allgemein</h5>
              {generalData}
              {this.getWinleasDiscount(winleas)}
            </Col>
            <Col xs={6}>
              {this.getWinleasSubsidy(winleas)}
              {this.getWinleasDeduction(winleas)}
              {this.getWinleasCommission(winleas)}
              {this.getWinleasResidualValue(winleas)}
            </Col>
          </Row>
        </Table>
      </div>
    );
  };

  render() {
    const {
      intl: { messages },
      winleases,
    } = this.props;

    return (
      <div class="panel panel-transparent">
        <div class="panel-body no-padding">
          <h4>
            {messages.sad.financing} / {messages.sad.leasing}
          </h4>
          {winleases.length === 0 ? <div>{messages.sad.no_winleas_data_available}</div> : ''}
          {_orderBy(
            winleases,
            [
              o => {
                return o.application_approval_date || '';
              },
              o => {
                return o.application_rejection_date || '';
              },
              o => {
                return o.application_date || '';
              },
              o => {
                return o.businessDate || '';
              },
            ],
            ['desc', 'desc', 'desc', 'desc']
          ).map(winleas => {
            return this.getWinLeasView(winleas);
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    projectConfig: state.data.projectConfig,
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(VklBusinessWinleas));
